import { render, staticRenderFns } from "./ignored-files.component.vue?vue&type=template&id=16fbe190&scoped=true&"
import script from "./ignored-files.component.vue?vue&type=script&lang=js&"
export * from "./ignored-files.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fbe190",
  null
  
)

export default component.exports